import { render, staticRenderFns } from "./leisure.vue?vue&type=template&id=e7e6015c"
import script from "./leisure.vue?vue&type=script&lang=js"
export * from "./leisure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports